import { useState, type ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';

function getInitialCollapsed(): boolean {
  try {
    const saved = localStorage.getItem('sidebar-collapsed');
    if (saved !== null) return saved === 'true';
  } catch {}
  // Default: collapsed on tablet (<1024px), expanded on desktop
  return typeof window !== 'undefined' && window.innerWidth < 1024;
}

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const [isCollapsed, setIsCollapsed] = useState(getInitialCollapsed);

  const handleToggle = () => {
    setIsCollapsed(prev => {
      const next = !prev;
      try { localStorage.setItem('sidebar-collapsed', String(next)); } catch {}
      return next;
    });
  };

  return (
    <div className="min-h-screen bg-surface-50 dark:bg-surface-900">
      {/* Desktop sidebar — hidden on mobile via Sidebar's own md:flex */}
      <Sidebar isCollapsed={isCollapsed} onToggle={handleToggle} />

      {/* Main content — shifts right on desktop to account for sidebar */}
      <main
        id="main-content"
        aria-label="Main content"
        className={`
          transition-all duration-300 ease-in-out
          pb-16 md:pb-0
          ${isCollapsed ? 'md:ml-16' : 'md:ml-60'}
        `}
      >
        {children}
      </main>

      {/* BottomNav — shown only on mobile (md:hidden inside BottomNav) */}
      <BottomNav />
    </div>
  );
}

export default AppShell;
